import React from 'react';
import Ink from 'react-ink';
import { compose, withProps } from 'recompose';
var enhance = compose(withProps(function (_ref) {
  var opacity = _ref.opacity,
      secondary = _ref.secondary;
  return {
    opacity: opacity ? opacity : secondary ? 0.04 : 0.1,
    background: false
  };
}));
var InkComponent = enhance(function (props) {
  return /*#__PURE__*/React.createElement(Ink, props);
});
export { InkComponent as Ink };